export default __webpack_public_path__ + "static/media/info-icon.4e21d101.svg";